<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="680px"
    :innerScroll="false"
    :loading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="110px" class="content">
      <el-row class="row-height">
        <el-col :span="6">
          <div class="right">{{rowData[0].impactFactors}}</div>
        </el-col>
        <el-col :span="10">
          <div class="center">
            <el-input v-model="addForm.weight" size="mini" style="width: 110px" @blur="inputNum(addForm.weight)" />%<span
              style="margin-left: 15px"
              >（权重占比）</span
            >
          </div>
        </el-col>
      </el-row>
      <el-row class="row-height">
        <el-col :span="6">
          <div class="right">下限</div>
        </el-col>
        <el-col :span="6">
          <div class="center">上限</div>
        </el-col>
        <el-col :span="6">
          <div class="center">得分</div>
        </el-col>
      </el-row>
      <el-row class="row-height inputNuber" v-for="(item, index) in addForm.rowData" :key="index">
        <el-col :span="3">
          <div class="right">区间{{ index + 1 }}</div>
        </el-col>
        <el-col :span="4">
          <div class="right">
            <el-input
              v-model="item.limitLower"
              :controls="false"
              step-strictly
              size="mini"
              @blur="downInput(item.limitLower, index)"
              style="width: 90px"
            />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="center">
            <el-input
              v-model="item.limitUpper"
              :controls="false"
              step-strictly
              @blur="inputNumType(item.limitUpper, index, 'limitUpper')"
              size="mini"
              style="width: 90px"
            />
          </div>
        </el-col>
        <el-col :span="2">
          <div class="right">分值</div>
        </el-col>
        <el-col :span="5">
          <div class="left" style="margin-left: 20px">
            <el-input
              v-model="item.score"
              size="mini"
              :controls="false"
              step-strictly
              @blur="inputNumType(item.score, index, 'score')"
              style="width: 90px"
            />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="right">
            <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="handleAdd(index)"></el-button>
            <el-button
              v-if="addForm.rowData.length"
              type="danger"
              icon="el-icon-minus"
              size="mini"
              circle
              @click="handleDelete(index)"
            ></el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="row-height">
        <el-col :span="3">
          <div class="right">备注</div>
        </el-col>
        <el-col :span="16">
          <div style="padding-left: 20px">
            <el-input
              v-model.trim="addForm.ruleDesc"
              type="textarea"
              maxlength="200"
              :autosize="{ minRows: 3, maxRows: 9 }"
              style="width: 360px"
            ></el-input>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Array,
    dataType: Number,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData[0].impactFactors + '因子维护';
    },
  },
  data() {
    return {
      loading: false,
      addForm: {
        rowData: [],
      },
      rules: {},
      imgList: "",
      skuCodeList: [],
      textForm: {},
      error: false,
    };
  },
  mounted() {},
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        let numType = false;
        let intersection = false 
        let equation = false 
        let rowData = this.addForm.rowData.map((v, index) => {
          if (v.limitLower == 0 && v.limitUpper == 0) {
            numType = true;
          }else if((+v.limitLower > +v.limitUpper) && v.limitUpper) {
            intersection = true
          }else if((+v.limitLower == +v.limitUpper) && v.limitUpper) {
            equation = true
          }
          return {
            ...v,
            ruleDesc: this.addForm.ruleDesc,
            weight: this.addForm.weight,
            unitDesc: this.rowData[0].unitDesc
            // unsalableLevel: this.numberType(index) + "级",
          };
        });
        if (numType) {
          this.$message.error("上限下限不能同时为0");
          return;
        }else if(intersection) {
          this.$message.error("下限不能大于上限");
          return;
        }else if(equation) {
          this.$message.error("下限不能等于上限");
          return;
        }
        let data = {};
        if (this.dataType == 2) {
          data = {
            dataType: 2,
            expectedSalesDaysList: rowData,
          };
        } else {
          data = {
            dataType: 3,
            marketTimeList: rowData,
          };
        }
        setTimeout(() => {
          if (this.error) return;
          this.loading = true;
          this.$q.newProduct
            .impactFactorsUpdate({ data: data })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("修改成功");
                this.isVisible = false;
                this.$emit("success");
              }
            })
            .finally((_) => {
              this.loading = false;
            });
        }, 200);
      });
    },
    downInput(num, index) {
      if (!num) return;
      let value = num + "";
      var reg = /^([0-9][0-9]{0,3}|9999)$/;
      if (!value.match(reg)) {
        this.$message.error("请输入0~9999的正整数");
        this.error = true;
        this.$set(this.addForm.rowData[index], "limitLower", "");
      } else {
        if(this.addForm.rowData[index + 1]) {
          this.$set(this.addForm.rowData[index + 1], "limitUpper", num);
        } 
        this.error = false;
      }
    },

    inputNumType(num, index, key) {
      if (!num) return;
      let value = num + "";
      var reg = /^([0-9][0-9]{0,3}|9999)$/;
      if (!value.match(reg)) {
        this.$message.error("请输入0~9999的正整数");
        this.error = true;
        this.$set(this.addForm.rowData[index], key, "");
      } else {
        if(key == 'limitUpper' && this.addForm.rowData[index - 1]) {
          this.$set(this.addForm.rowData[index - 1], "limitLower", num);
        }
        this.error = false;
      }
    },

    inputNum(num) {
      if (!num) return;
      let value = num + "";
      var reg = /^([0-9][0-9]{0,3}|9999)$/;
      if (!value.match(reg)) {
        this.error = true;
        this.$message.error("请输入0~9999的正整数");
        this.$set(this.addForm, "weight", "");
      } else {
        this.error = false;
      }
    },

    handleAdd(index) {
      if (this.addForm.rowData.length == 10) {
        this.$message.error("已达到最大区间数量！");
        return;
      }
      this.addForm.rowData.splice(index + 1, 0, this.getNewItem());
    },
    handleDelete(index) {
      if (this.addForm.rowData.length == 3) {
        this.$message.error("至少存在三个区间！");
        return;
      }
      this.addForm.rowData.splice(index, 1);
    },
    getNewItem(index) {
      return {
        limitUpper: "",
        limitLower: "",
        score: "",
      };
    },
    numberType() {
      let numberChina = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return numberChina[this.rowData.length];
    },
  },
  created() {
    this.$set(this.addForm, "rowData", this.rowData);
    this.$set(this.addForm, "weight", this.rowData[0].weight);
    this.$set(this.addForm, "ruleDesc", this.rowData[0].ruleDesc);
  },
};
</script>

<style lang="stylus" scoped>

.content {
  max-height: 70vh
  overflow-y: auto
}

>>> .el-dialog {
  margin: 50px auto !important
}
.left {
  text-align: left
}
.right {
  text-align: right
}
.center {
  text-align: center
}
.row-height {
  height: 28px
  margin-top: 20px;
  line-height: 28px
}
 .el-select >>> .el-input {
   width: 360px
 }
 .el-input-number >>> .el-input {
   width: 90px
 }
  >>>.inputNuber .el-input--mini .el-input__inner {
  text-align: center
 }
</style>
